import React from "react";
import "./ProjectFFWBCW.scss";
import GenericHero from "../../components/GenericHero/GenericHero";
import ffwbcwImg from "../../assets/images/mockupFFWBCW.png";
import Carousel from "../../components/Carousel/Carousel";
import Heading from "../../components/Heading/Heading";
import { ffwbcwCarouselContents } from "./ffwbcwCarouselContents";
import reactLogo from "../../assets/icons/react.svg";
import sassLogo from "../../assets/icons/sass.svg";
import typeLogo from "../../assets/icons/typescript.svg";
import emailLogo from "../../assets/icons/emailjs.svg";
import netlifyLogo from "../../assets/icons/netlify.svg";

export default function ProjectFFWBCW() {
  return (
    <div className="ffwbcwPage">
      <GenericHero
        head="First Free Will Baptist"
        text="A timeless user-friendly website to provide a welcoming online presence for First Free Will Baptist. Designed with clarity and simplicity in mind, this project provides essential church information for visitors thinking of attending."
        hImg={ffwbcwImg}
        hAlt="A mockup of several pages from ffwbcw.org"
        btnContent="Read More"
        btnLink="#ffwbcwDetails"
        btn2Content="Visit Website"
        btn2Link="http://ffwbcw.org"
      />
      <section className="ffwbcwPage__details" id="ffwbcwDetails">
        <Heading content="Details" />
        <div className="ffwbcwPage__container">
          <section className="ffwbcwPage__content">
            <p className="ffwbcwPage__desc">
              With a desire to connect better with the local community, the
              pastor approached me to build his church’s first online presence.
              After analyzing several websites he liked, I designed a site that
              reflects the church's timeless and stable character. The result is
              a clean, simple, and easy-to-use design that suits the church's
              needs while being predictable and intuitive for new visitors.
            </p>
            <p className="ffwbcwPage__desc">
              The church needed a static site to provide essential information.
              Using React and TypeScript, I developed a serverless SPA that
              delivers these features efficiently. One challenge was
              implementing a contact form without a server, which I solved by
              integrating the Email.js API, providing easy communication for
              visitors while keeping the site lightweight.
            </p>
            <p className="ffwbcwPage__desc">
              Since its launch, the website has been praised by both visitors
              and church members for its intuitive layout, predictable
              navigation, and convenient contact form. Designed to be responsive
              and dynamic, the site provides a welcoming experience for all
              users.
            </p>
            <p className="ffwbcwPage__desc">
              I continue to provide ongoing support and updates, such as adding
              an event page with an announcement banner. Through this project I
              developed my confidence in TypeScript and honed my communication
              skills, preparing me for future projects.
            </p>
          </section>
          <Carousel items={ffwbcwCarouselContents} />
        </div>
      </section>
      <section className="techstack">
        <Heading content="Tech Stack" />
        <div className="techstack__front">
          <p className="techstack__title">Front End</p>
          <ul className="techstack__list">
            <li className="techstack__item">
              <img
                src={reactLogo}
                alt="React Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">React</p>
            </li>
            <li className="techstack__item">
              <img
                src={sassLogo}
                alt="SASS/SCSS Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">SASS/SCSS</p>
            </li>
            <li className="techstack__item">
              <img
                src={typeLogo}
                alt="TypeScript Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">TypeScript</p>
            </li>
            <li className="techstack__item">
              <img
                src={emailLogo}
                alt="Axios Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Axios</p>
            </li>
            <li className="techstack__item">
              <img
                src={netlifyLogo}
                alt="Netlify Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Netlify</p>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}
